import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '../../quotes/quote';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';
import ReviewQuoteMachineComponent from '../../quotes/review/quote-details/ReviewQuoteMachineComponent';
import ReviewQuoteCouplerDecision from '../../quotes/review/quote-products/ReviewQuoteCouplerDecision';
import QuoteWizardContext from '../../quotes/QuoteWizardContext';
import { QuoteProductDto } from '../../quotes/otherQuoteEntities';

export default class MachineInformationContainer extends React.Component {
  static contextType = QuoteWizardContext;
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    quoteProductDto: PropTypes.instanceOf(QuoteProductDto).isRequired,
    isEditProductMode: PropTypes.bool.isRequired,
    onQuoteProductDtoChange: PropTypes.func.isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration).isRequired,
    show: PropTypes.bool.isRequired,
    onloadSharedDocuments: PropTypes.func.isRequired,
    onSaved: PropTypes.func,
    isFromStep3InventoryOnly: PropTypes.bool
  };

  render() {
    const {
      quote,
      quoteProductDto,
      onQuoteProductDtoChange,
      quoteProductConfiguration,
      show,
      onloadSharedDocuments,
      isFromStep3InventoryOnly
    } = this.props;
    const { onQuoteUpdate, getQuoteDealerBranch, getQuoteCarrierMachines } =
      this.context;
    const quoteAttachmentPoint = quote.attachmentPoints.find(
      (x) => x.id === quoteProductDto.attachmentPointId
    );
    const productGroup = quoteProductConfiguration.productGroups.find(
      (x) => x.id === quoteProductDto.productGroupId
    );

    return (
      <div>
        {show && (
          <div className="hr-divider">
            <h3 className="hr-divider-content hr-divider-heading">
              Machine Information
            </h3>
          </div>
        )}
        <div className="row">
          <div className="col-6">
            <ReviewQuoteMachineComponent
              quote={quote}
              onUpdate={(updatedQuote) => onQuoteUpdate(updatedQuote)}
              machines={getQuoteCarrierMachines()}
              preferredMakeIds={getQuoteDealerBranch().preferredMakes}
              quoteProductConfiguration={quoteProductConfiguration}
              isFromStep3={true}
              quoteProductDto={quoteProductDto}
              onQuoteProductDtoChange={onQuoteProductDtoChange}
              showNonModalContent={show}
              onloadSharedDocuments={onloadSharedDocuments}
              onSaved={this.props.onSaved}
              isFromStep3InventoryOnly={isFromStep3InventoryOnly}
            />
          </div>
          <div className="col-6">
            <ReviewQuoteCouplerDecision
              quote={quote}
              attachmentPoint={quoteProductConfiguration.attachmentPoints.find(
                (x) => x.id === quoteProductDto.attachmentPointId
              )}
              anyCouplerAffected={productGroup?.isCoupler ?? false}
              defaultCouplerType={null}
              quoteAttachmentPoint={quoteAttachmentPoint}
              onQuoteAttachmentPointUpdated={(updatedQuote) =>
                onQuoteUpdate(updatedQuote)
              }
              couplerStyles={quoteProductConfiguration.couplerStyles.filter(
                (x) => x.attachmentPointId === quoteProductDto.attachmentPointId
              )}
              multiAttachmentPoints={false}
              isFromStep3={true}
              quoteProductDto={quoteProductDto}
              onQuoteProductDtoChange={onQuoteProductDtoChange}
              showNonModalContent={show}
              onloadSharedDocuments={onloadSharedDocuments}
              machines={getQuoteCarrierMachines()}
              quoteProductConfiguration={quoteProductConfiguration}
              onSaved={this.props.onSaved}
              isFromStep3InventoryOnly={isFromStep3InventoryOnly}
            />
          </div>
        </div>
      </div>
    );
  }
}
